<template>
    <flat-pickr v-if="dateConfig" ref="picker" v-model="date" class="date-picker" :config="dateConfig" :disabled="disabled"
                :class="{ 'is-invalid': !state && state != null }" @input="dateUpdated" @on-open="onOpen"></flat-pickr>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css';
    import { Danish } from "flatpickr/dist/l10n/da.js";

    export default {
        components: { flatPickr },
        props: {
            value: null,
            state: null,
            time: Boolean,
            disabled: Boolean
        },
        watch: {
            // vue-flatpickr-component only syncs `disabled` to the hidden input, so mirror it onto the visible alt input
            disabled: {
                immediate: true,
                handler(val) {
                    this.$nextTick(() => {
                        var fp = this.$refs.picker && this.$refs.picker.fp
                        if (fp && fp.altInput) {
                            fp.altInput.disabled = val
                        }
                    })
                }
            }
        },
        data: () => ({
            dateConfig: null
        }),
        computed: {
            date: {
                get() {
                    let val = this.value
                    if (!val) return val

                    // Interpret incoming as UTC, then convert to Denmark time
                    const dkMoment = this.$moment.tz(val, 'UTC').tz('Europe/Copenhagen')

                    // If your flatpickr uses ISO strings:
                    const isoForFlatpickr = dkMoment.format('YYYY-MM-DDTHH:mm:ss')

                    return isoForFlatpickr
                },
                set(val) {
                    // val is "2025-09-29T08:00:00" in Denmark time.
                    // Convert back to UTC for your model if needed:
                    if (!val) {
                        this.$emit('input', null)
                        return
                    }

                    const utcString = this.$moment
                        .tz(val, 'Europe/Copenhagen')
                        .utc()
                        .format('YYYY-MM-DD HH:mm:ss[Z]') // "2025-09-29 06:00:00Z"

                    this.$emit('input', utcString)
                }
            }
        },
        created() {
            this.dateConfig = {
                wrap: true,
                altFormat: 'j. M, Y \\k\\l\\. H:i',
                altInput: true,
                dateFormat: 'Y-m-dTH:i:S',
                locale: Danish,
                weekNumbers: true,
                enableTime: this.time,
                onChange(val) {
                    //console.log("onChange", val)
                }
            }
        },
        mounted() { },
        methods: {
            onOpen() {
                if (this.disabled && this.$refs.picker && this.$refs.picker.fp) {
                    this.$refs.picker.fp.close()
                }
            },
            dateUpdated(val) {
                if (!val) {
                    this.date = null
                }

                this.$emit('update', val)
            }
        },
    }
</script>

<style lang="scss">
    .date-picker {
        &[readonly] {
            background-color: #ffffff !important;
        }

        &.is-invalid + input.form-control {
            border-color: #ea5455;
        }
    }
</style>